import {Component} from '@angular/core';

@Component({
  selector: 'app-full-screen-footer',
  templateUrl: './full-screen-footer.component.html',
  styleUrls: ['./full-screen-footer.component.scss']
})
export class FullScreenFooterComponent {

  constructor() {
  }
}
